/* unplugin-vue-components disabled */import { render } from "./UploadImageSVG.vue?vue&type=template&id=018fe4a3"
import script from "./UploadImageSVG.vue?vue&type=script&lang=js"
export * from "./UploadImageSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__